import { isSafeAuthReturnTo } from './authReturnTo';

export const AUTH_EXPIRED_EVENT = 'jg:auth-expired';

let lastAuthExpiredAt = 0;
const AUTH_EXPIRED_DEDUPE_MS = 1500;

const AUTH_RECOVERY_EXCLUDED_PREFIXES = [
  'players/login',
  'players/signup',
  'players/register',
  'players/forgot',
  'players/reset',
  'auth/',
];

function readHeader(headers, name) {
  if (!headers) return '';
  const direct = headers[name] || headers[name.toLowerCase()];
  if (direct) return direct;
  if (typeof headers.get === 'function') {
    return headers.get(name) || headers.get(name.toLowerCase()) || '';
  }
  return '';
}

function normalizeUrl(url) {
  return String(url || '').replace(/^\/+/, '');
}

export function isUnauthorizedError(error) {
  return Number(error?.response?.status) === 401;
}

export function getCurrentSafeReturnTo() {
  if (typeof window === 'undefined') return null;
  const path = `${window.location?.pathname || '/'}${
    window.location?.search || ''
  }${window.location?.hash || ''}`;
  return isSafeAuthReturnTo(path) ? path : null;
}

export function shouldRecoverFromAuthError(error) {
  if (!isUnauthorizedError(error)) return false;

  const config = error?.config || {};
  if (config.skipAuthExpiredRecovery) return false;

  const url = normalizeUrl(config.url);
  if (!url) return false;
  if (AUTH_RECOVERY_EXCLUDED_PREFIXES.some((prefix) => url.startsWith(prefix))) {
    return false;
  }

  const authHeader =
    readHeader(config.headers, 'Authorization') ||
    readHeader(config.headers?.common, 'Authorization');
  return /^Bearer\s+\S+/i.test(String(authHeader || ''));
}

export function clearStoredPlayerSession() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem('player');
  } catch (err) {
    // Storage can be unavailable in privacy modes. Recovery should continue.
  }
}

export function triggerAuthExpiredRecovery(detail = {}) {
  if (typeof window === 'undefined') return false;

  const now = Date.now();
  if (now - lastAuthExpiredAt < AUTH_EXPIRED_DEDUPE_MS) return false;
  lastAuthExpiredAt = now;

  const returnTo = detail.returnTo || getCurrentSafeReturnTo();
  clearStoredPlayerSession();

  if (returnTo) {
    try {
      window.localStorage.setItem('jg:returnTo', returnTo);
    } catch (err) {
      // Ignore storage failures; the event still lets the app recover.
    }
  }

  window.dispatchEvent(
    new CustomEvent(AUTH_EXPIRED_EVENT, {
      detail: {
        ...detail,
        returnTo,
        reason: detail.reason || 'protected-api-401',
      },
    }),
  );
  return true;
}

export function __resetAuthExpiredDedupeForTests() {
  lastAuthExpiredAt = 0;
}
